import { render } from "./ChangePaymentFrequencyForm.vue?vue&type=template&id=120b9ba6"
import script from "./ChangePaymentFrequencyForm.vue?vue&type=script&lang=js"
export * from "./ChangePaymentFrequencyForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__